import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialog, ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { SelectModule } from 'primeng/select';
import {
  CommunicationService,
  InstituicaoGestoraService,
  MunicipioService,
  PaisService,
  ProvinciaService,
  RepresentacaoInstituicaoGestoraService,
  TipoRepresentacaoInstituicaoGestoraService,
} from '../../api/services';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ApiService } from '@core/providers/http';
import { TabsModule } from 'primeng/tabs';
import { DropdownModule } from 'primeng/dropdown';
import { EditInstituicoesGestoraComponent } from '../edit-instituicoes-gestora/edit-instituicoes-gestora.component';
import { DrawerModule } from 'primeng/drawer';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginatorModule } from 'primeng/paginator';
import { InputTextModule } from 'primeng/inputtext';
import { FilterItem, RepresentacaoInstituicaoGestora } from '../../api/models';
import { InstituicaoGestora } from '../../api/models/instituicao-gestora.model';
import { MaisdetalhesInstituicoesGestorasComponent } from '../maisdetalhes-instituicoes-gestoras/maisdetalhes-instituicoes-gestoras.component';
import { EnumToStringPipe } from '@app/features-modules/gestao-bolseiros/pipes/enum-to-string.pipe';
import { RepresentanteCardComponent } from './add-representante/components/representante-card/representante-card.component';
import { Pagination } from '@app/shared/model';
import { TagModule } from 'primeng/tag';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { DialogModule } from 'primeng/dialog';
import { DataVoidComponent } from '../../../../../shared/components/data-void/data-void.component';
import { EditRepresentanteComponent } from './add-representante/components/edit-representante/edit-representante.component';
import { InstituicoesEnsinoListarBolseirosComponent } from './components/instituicoes-ensino-listar-bolseiros/instituicoes-ensino-listar-bolseiros.component';
import { ListarInstituicaoDeEnsinoComponent } from './components/listar-instituicao-de-ensino/listar-instituicao-de-ensino.component';
import { Subscription } from 'rxjs';
import { RedefinirSenhaComponent } from '@app/shared/components/redefinir-senha/redefinir-senha.component';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-detalhe-instituicao-gestora',
  imports: [
    CommonModule,
    BackButtonComponent,
    ButtonModule,
    ToastModule,
    ConfirmDialog,
    TabsModule,
    ConfirmDialogModule,
    DropdownModule,
    DrawerModule,
    SelectModule,
    FormsModule,
    PaginatorModule,
    InputTextModule,
    ReactiveFormsModule,
    MaisdetalhesInstituicoesGestorasComponent,
    EnumToStringPipe,
    RepresentanteCardComponent,
    EnumToStringPipe,
    TagModule,
    PaginatorControlComponent,
    EditRepresentanteComponent,
    SearchBarComponent,
    DialogModule,
    DataVoidComponent,
    InstituicoesEnsinoListarBolseirosComponent,
    ListarInstituicaoDeEnsinoComponent,
    AvatarModule,
  ],
  providers: [
    ApiService,
    MessageService,
    CommunicationService,
    DialogService,
    RepresentacaoInstituicaoGestoraService,
    ConfirmationService,
    InstituicaoGestoraService,
    PaisService,
    ProvinciaService,
    MunicipioService,
    TipoRepresentacaoInstituicaoGestoraService,
    DynamicDialogRef,
  ],
  templateUrl: './detalhe-instituicao-gestora.component.html',
  styleUrl: './detalhe-instituicao-gestora.component.scss',
  standalone: true,
})
export class DetalheInstituicaoGestoraComponent implements OnInit, OnDestroy {
  imageError = false;

  getInitials(name?: string | null): string {
    return getInitials(name);
  }
  route = inject(ActivatedRoute);
  router = inject(Router);
  confirmationService = inject(ConfirmationService);
  dialogService = inject(DialogService);
  ref = inject(DynamicDialogRef);
  messageService = inject(MessageService);
  communicationService = inject(CommunicationService);
  apiService = inject(ApiService);
  representanteInstituicaoGestora = inject(
    RepresentacaoInstituicaoGestoraService
  );
  form!: FormGroup;
  instituicaoGestoraService = inject(InstituicaoGestoraService);

  empresas: any[] = [];
  sortFields: any[] = [
    {
      label: 'Nome',
      value: 'nome',
    },
  ];

  @Input() mode: string = 'list';
  @Output() formValueChange = new EventEmitter<any>();
  tiposRepresentacao: any[] = [];

  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'Nome',
      placeholder: 'Pesquise por nome',
    },
    {
      type: 'text',
      controlName: 'EmailRepresentante',
      placeholder: 'Pesquise por email',
    },
    {
      type: 'text',
      controlName: 'Telefone',
      placeholder: 'Pesquise por telefone',
    },
  ];

  perfilEmpresagestora: any;
  idInstituicao!: number;

  pagination: Pagination<any> = new Pagination<any>();
  formacaoCount = 0;
  activeTab: number = 0;
  isLoading: boolean = false;
  visible: boolean = false;
  //ref: DynamicDialogRef | undefined;
  instituicao: InstituicaoGestora | undefined | null;
  private tipoRepresentacaoService = inject(
    TipoRepresentacaoInstituicaoGestoraService
  );
  paisService = inject(PaisService);
  provinciaService = inject(ProvinciaService);
  municipioService = inject(MunicipioService);
  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  private subscriptions = new Subscription();

  constructor(private fb: FormBuilder) { }

  @ViewChild(InstituicoesEnsinoListarBolseirosComponent)
  private InstituicoesListarBolseirosCmp!: InstituicoesEnsinoListarBolseirosComponent;

  @ViewChild(ListarInstituicaoDeEnsinoComponent)
  private InstituicoesListarCmp!: ListarInstituicaoDeEnsinoComponent;

  representantes: RepresentacaoInstituicaoGestora[] = [];
  fotoPreviewMap: { [id: number]: string | ArrayBuffer | null } = {};

  ngOnInit(): void {
    this.form = this.fb.group({
      Nome: [null],
      EmailRepresentante: [null],
      Telefone: [null],
    });
    this.loadInstitutionGestoraDetails(this.instituicaoGestoraID);
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (id) {
      this.getPhoto(id);
    }
    //this.toggleInstituicaoGestoraStatus();
    this.route.params.subscribe((params) => {
      this.idInstituicao = +params['id'];
      this.loadRepresentantes();
    });
    this.loadTiposRepresentacao();

    this.loadCountries();
    this.subscriptions.add(
      this.communicationService.countryChanged$.subscribe(
        (country: string | null) => {
          if (country) {
            this.loadProvinces(country);
          }
        }
      )
    );

    this.subscriptions.add(
      this.communicationService.provinceChanged$.subscribe(
        (province: string | null) => {
          if (province) {
            this.loadMunicipalities(province);
          }
        }
      )
    );
  }

  ngOnDestroy(): void {
    if (this.ref) {
      this.ref.close();
    }
  }

  /*initializeForm() {
    this.filters.forEach(filter => {
      this.searchForm.addControl(filter.controlName, new FormControl(''));
    });
  }*/

  loadImagemInstituicaoGestora(id: number) {
    this.instituicaoGestoraService.getFotoInstituicaoGestoraById(id).subscribe({
      next: (response) => {
        if (!response || !response.type.startsWith('image/')) {
          console.warn('Resposta não é imagem. A usar placeholder.');
          this.imagePreview = null;
          return;
        }
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreview = reader.result;
        };
        reader.readAsDataURL(response);
      },
      error: (err) => {
        console.error('Erro ao carregar imagem da instituição:', err);
        this.imagePreview = null;
      },
    });
  }

  toggleInstituicaoGestoraStatus() {
    const novoStatus = !this.perfilEmpresagestora?.activo;
    this.confirmationService.confirm({
      header: novoStatus ? 'Ativar Empresa?' : 'Desativar Empresa?',
      message: `Tem certeza que deseja ${novoStatus ? 'ativar' : 'desativar'
        } a empresa "${this.perfilEmpresagestora?.nome}"?`,
      acceptLabel: 'Sim',
      rejectLabel: 'Cancelar',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.isLoading = true;
        this.instituicaoGestoraService
          .toggleStatus(this.instituicaoGestoraID)
          .subscribe({
            next: () => {
              this.loadInstitutionGestoraDetails(this.instituicaoGestoraID);
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: `Empresa gestora ${novoStatus ? 'ativada' : 'desativada'
                  } com sucesso.`,
              });
              this.isLoading = false;
            },
            error: (err) => {
              console.error('Erro ao actualizar status:', err);
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail: 'Não foi possível alterar o status da empresa gestora.',
              });
              this.isLoading = false;
            },
          });
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelado',
          detail: 'Ação cancelada.',
        });
      },
    });
  }

  loadTiposRepresentacao() {
    this.tipoRepresentacaoService.list().subscribe((tiposRepresentacao) => {
      this.tiposRepresentacao = tiposRepresentacao.data;
      this.filters[1].options = this.tiposRepresentacao;
    });
  }

  loadInstitutionGestoraDetails(instituicaoGestoraID: string) {
    this.instituicaoGestoraService.show(instituicaoGestoraID).subscribe({
      next: (result: any) => {
        this.perfilEmpresagestora = result;
      },
      error: (error) => {
        console.error('Erro ao carregar detalhes da Empresa Gestora', error);
      },
    });
  }

  loadRepresentanteInstGestoraDetails(representanteinstiGestoraID: string) {
    this.representanteInstituicaoGestora
      .show(representanteinstiGestoraID)
      .subscribe({
        next: (result: any) => {
          this.representantes = result;
        },
        error: (error) => {
          console.error('Erro ao carregar detalhes da Empresa Gestora', error);
        },
      });
  }

  loadRepresentantes(queryParams?: any) {
    const params = {
      ...queryParams,
      instituicaoGestoraID: this.instituicaoGestoraID, // <-- Filtro pela instituição gestora
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      OrderBy: queryParams?.OrderBy || 'id desc',
    };
    this.representanteInstituicaoGestora.list(params).subscribe({
      next: (response) => {
        this.representantes = response.data;
        this.pagination = new Pagination<any>().deserialize(response);

        this.representantes.forEach((repre: any) => {
          if (repre.id) {
            this.loadImagemRepresentante(repre.id);
          }
        });
      },
      error: (error) => {
        console.error('Erro ao carregar representantes:', error);
      },
    });
  }

  get instituicaoGestoraID(): any {
    return this.route.snapshot.paramMap.get('id');
  }

  loadImagemRepresentante(id: number): void {
    this.representanteInstituicaoGestora
      .getFotoRepresentacaoInstituicaoGestoraById(id)
      .subscribe({
        next: (response) => {
          const reader = new FileReader();
          reader.onload = () => {
            this.fotoPreviewMap[id] = reader.result as string;
          };
          reader.readAsDataURL(response);
        },
      });
  }

  getPhoto(id: number) {
    this.instituicaoGestoraService.getFotoInstituicaoGestoraById(id).subscribe({
      next: (response) => {
        if (!response || !response.type.startsWith('image/')) {
          console.warn('Resposta não é imagem. A usar placeholder.');
          this.imagePreview = null;
          return;
        }
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreview = reader.result;
        };
        reader.readAsDataURL(response);
      },
      error: (err) => {
        console.error('Erro ao carregar imagem da empresa:', err);
        this.imagePreview = null;
      },
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadRepresentantes();
  }

  trackById(index: number, item: any): number {
    return item.id;
  }

  setFormacaoCount(count: number) {
    this.formacaoCount = count;
  }

  loadCountries() {
    this.paisService.list().subscribe((countries) => {
      this.countries = countries;
    });
  }

  loadProvinces(country: string) {
    this.provinciaService.list(country).subscribe((provinces) => {
      this.provinces = provinces;
      this.communicationService.updateProvinces(provinces);
      this.municipalities = []; // Reset municipalities when country changes
    });
  }

  loadMunicipalities(province: string) {
    this.municipioService.list(province).subscribe((municipalities) => {
      this.municipalities = municipalities;
      this.communicationService.updateMunicipalities(municipalities);
    });
  }

  showDialog() {
    if (!this.instituicaoGestoraID) return;

    this.ref = this.dialogService.open(EditInstituicoesGestoraComponent, {
      width: '45%',
      data: {
        perfilEmpresagestora: this.perfilEmpresagestora,
        imagePreview: this.imagePreview,
        countries: this.countries,
        provinces: this.provinces,
        municipalities: this.municipalities,
      },
    });

    this.ref.onClose.subscribe((data) => {
      if (data instanceof FormData) {
        this.isLoading = true;
        this.instituicaoGestoraService
          .update(data, this.instituicaoGestoraID)
          .subscribe({
            next: () => {
              this.loadInstitutionGestoraDetails(this.instituicaoGestoraID);
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Empresa gestora actualizada com sucesso!',
              });
              this.isLoading = false;
              setTimeout(
                () =>
                  this.router.navigate([
                    `/gestao-bolseiros/empresa-gestora/detalhe-instituicao-gestora/${this.instituicaoGestoraID}`,
                  ]),
                2000
              );
            },
            error: (error) => {
              console.error('Erro ao actualizar empresa gestora:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro ao actualizar empresa gestora.',
              });
              this.isLoading = false;
            },
          });
      }
    });
  }

  // toggleInstituicaoGestoraStatus() {
  //   this.isLoading = true;
  //   const id = this.instituicaoGestoraID;

  //   const novoStatus = !this.perfilEmpresagestora.activo;
  //   this.instituicaoGestoraService.toggleStatus(id).subscribe({
  //     next: () => {
  //       this.loadInstitutionGestoraDetails(id);
  //       this.messageService.add({
  //         severity: 'success',
  //         summary: 'Sucesso',
  //         detail: `Empresa gestora ${
  //           novoStatus ? 'ativada' : 'desativada'
  //         } com sucesso.`,
  //       });
  //       this.isLoading = false;
  //     },
  //     error: (err) => {
  //       console.error('Erro ao actualizar status:', err);
  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'Erro',
  //         detail: 'Não foi possível alterar o status da empresa gestora.',
  //       });
  //       this.isLoading = false;
  //     },
  //   });
  // }

  desativarEmpresa(id: string) {
    if (id) {
      this.confirmationService.confirm({
        header: 'Desativar Empresa?',
        message: `A empresa ${this.perfilEmpresagestora?.nome ?? 'selecionada'
          } será desativada. Deseja continuar?`,
        rejectButtonProps: {
          label: 'Cancelar',
          icon: 'pi pi-times',
          outlined: true,
          size: 'small',
        },
        acceptButtonProps: {
          label: 'Sim',
          icon: 'pi pi-check',
          size: 'small',
        },
        accept: () => {
          this.isLoading = true; // Iniciar carregamento
          this.instituicaoGestoraService.delete(id).subscribe(
            () => {
              this.empresas = this.empresas.filter(
                (empresa) => empresa.id !== id
              );
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Empresa gestora desativada com sucesso!',
              });
              this.isLoading = false; // Parar carregamento
              // Wait 2 seconds before redirecting
              setTimeout(() => {
                this.router.navigate(['/gestao-bolseiros/empresa-gestora']);
              }, 3000);
            },
            (error: any) => {
              console.error('Erro ao desativar empresa gestora:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro ao desativar empresa gestora.',
              });
              this.isLoading = false; // Parar carregamento
            }
          );
        },
        reject: () => {
          this.messageService.add({
            severity: 'info',
            summary: 'cancelada',
            detail: 'Empresa gestora não desativada',
          });
        },
      });
    }
  }

  showMaisDetalhes(item: any) {
    this.instituicao = item;
    this.visible = true;
  }

  irParaAddRepresentante(): void {
    // if (!this.instituicaoGestoraID) {
    //   console.error('ID da instituição gestora não definido.');
    //   return;
    // }
    this.router.navigate([
      '/gestao-bolseiros/empresa-gestora/add-representante',
      this.instituicaoGestoraID,
    ]);
  }

  editarRepresentante(representante: any) {
    const ref = this.dialogService.open(EditRepresentanteComponent, {
      header: 'Editar Representante',
      width: '45%',
      showHeader: false,
      modal: true,
      data: {
        representantes: this.representantes, // Lista de representantes
        perfilRepresentante: representante, // Representante selecionado
        representante: representante, // Certifique-se de que o representante não é undefined
      },
    });

    ref.onClose.subscribe((data) => {
      if (data instanceof FormData) {
        this.isLoading = true;
        this.representanteInstituicaoGestora
          .update(data, representante.id)
          .subscribe({
            next: () => {
              this.loadRepresentantes(); // Recarrega os representantes após a actualização
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Representante actualizado com sucesso!',
              });
              this.isLoading = false;
            },
            error: (error) => {
              console.error('Erro ao actualizar representante:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro ao actualizar representante.',
              });
              this.isLoading = false;
            },
          });
      }
    });
  }

  redefinirSenhaRepresentante(representante: any) {
    const ref = this.dialogService.open(RedefinirSenhaComponent, {
      header: 'Redefinir Senha do Representante',
      width: '45%',
      showHeader: false,
      modal: true,
      data: {
        representante,
      },
    });

    ref.onClose.subscribe((data) => {
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Senha redefinida',
          detail: `Senha redefinida para o usuário ${data.username}.`,
        });

        // Caso queira actualizar algo visualmente, pode fazer aqui
        // this.carregarRepresentantes();
      }
    });
  }

  desativarRepresentante(representante: any) {
    // Logic for deactivating the representative
    this.confirmationService.confirm({
      header: 'Confirmar Exclusão?',
      message: `Tem certeza que deseja excluir ${representante.nome || representante?.nomeRepresentante
        }?`,
      accept: () => {
        this.isLoading = true;
        this.representanteInstituicaoGestora
          .delete(representante.id)
          .subscribe({
            next: () => {
              this.loadRepresentantes();
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Representante excluído com sucesso!',
              });
              this.isLoading = false;
            },
            error: (error) => {
              console.error('Erro ao excluir representante:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro ao excluir representante.',
              });
              this.isLoading = false;
            },
          });
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelada',
          detail: 'Exclusão cancelada',
        });
      },
    });
  }

  notificarRepresentante() {
    console.log('End-point em produção');
  }

  onTabClick(tabIndexOrEvent: number | Event) {
    // se veio um Event, a gente usa o índice atual
    const idx =
      typeof tabIndexOrEvent === 'number' ? tabIndexOrEvent : this.activeTab;
    console.log('Tab clicked:', idx);
    switch (idx) {
      case 0:
        this.InstituicoesListarBolseirosCmp.loadBolseirosByInstituicaoEnsino(this.instituicaoGestoraID
        );
        break;
      case 1:
        this.InstituicoesListarCmp.getAllInstituicoesEnsino();
        break;
      case 2:
        this.loadRepresentantes();
        break;
    }
  }

  showFilter = false;

  showFilterModal() {
    this.showFilter = true;
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ''
      )
    );
    this.loadRepresentantes(filters);
    this.showFilter = false;
  }
}
